export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: '韩漫屋上的漫画资源是免费阅读的吗？',
    answer: '是的，韩漫屋上提供的所有韩国漫画推荐和资源均为免费在线阅读。我们致力于为广大漫画爱好者提供高质量的韩国漫画推荐服务，让每一位读者都能轻松享受优质的漫画内容。',
  },
  {
    question: '韩漫屋推荐漫画的更新频率是怎样的？',
    answer: '我们的编辑团队每天都会关注韩国漫画的最新动态，确保推荐的漫画资源始终保持新颖。热门连载漫画通常会在官方更新后的24小时内同步推荐，让您不会错过任何精彩内容。',
  },
  {
    question: '如何在韩漫屋上找到适合自己口味的漫画？',
    answer: '您可以通过首页的分类导航（浪漫爱情、热血动作、奇幻冒险、悬疑推理、日常治愈、剧情深度）浏览不同类型的漫画。每部漫画都有详细的评分、标签和简介，帮助您快速判断是否符合自己的喜好。',
  },
  {
    question: '韩漫屋推荐漫画的评分标准是什么？',
    answer: '我们的评分系统综合考虑了画风质量、剧情深度、人物塑造、读者反馈等多个维度。评分由专业编辑团队和读者投票共同决定，力求客观公正地反映每部漫画的真实水准。',
  },
  {
    question: '韩漫屋支持在手机上阅读吗？',
    answer: '当然支持！韩漫屋采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备访问，都能获得流畅舒适的阅读体验。',
  },
  {
    question: '我可以在韩漫屋上找到已完结的韩国漫画吗？',
    answer: '可以的。除了热门的连载漫画外，我们也精心筛选了大量已完结的优质韩国漫画，覆盖多种类型。您可以通过"已完结"标签找到这些作品，享受一口气看完的畅快体验。',
  },
  {
    question: '韩漫屋是否有漫画收藏和追更提醒功能？',
    answer: '目前韩漫屋主要提供漫画推荐和介绍服务。我们正在开发收藏和追更功能，敬请期待。您可以通过订阅我们的Newsletter获取最新的漫画推荐资讯。',
  },
  {
    question: '如何联系韩漫屋的编辑团队？',
    answer: '您可以通过"关于我们"页面上的联系表单或发送邮件至 contact@hanmanwu.com 与我们取得联系。无论是漫画推荐建议、合作意向还是问题反馈，我们都非常欢迎您的来信。',
  },
];

export const reviews = [
  {
    name: '小雨',
    role: '韩漫爱好者',
    content: '韩漫屋是我发现好看韩国漫画的第一站！分类清晰，推荐质量很高，几乎每次来都能找到对胃口的新作品。《咖啡与猫》就是在这里发现的，现在已经成为我的最爱了。',
    rating: 5,
  },
  {
    name: '阿杰',
    role: '漫画博主',
    content: '作为一名漫画博主，韩漫屋的推荐准确度让我印象深刻。评分系统很客观，文章分析也很专业。我经常参考这里的评测来写自己的漫评。强烈推荐给所有韩漫读者！',
    rating: 5,
  },
  {
    name: '小琳',
    role: '大学生',
    content: '课余时间最喜欢来韩漫屋逛逛，推荐质量真的很高！《她的秘密花园》和《画中仙》都是在这里被种草的。网站界面也很清爽，浏览体验很好。',
    rating: 5,
  },
];